import React from 'react'

import { TOAST_VARIANT_INFO, toastShow } from 'mailup-web-components'

import NotifySaveSegmentSuccess from 'Pages/RecipientsList/components/filters/segments/NotifySaveSegmentSuccess'

export const notifySaveSuccess = (): void => {
  toastShow(<NotifySaveSegmentSuccess />, TOAST_VARIANT_INFO)
}
